import { render } from "./CustomizeEventAdd.vue?vue&type=template&id=6ff55854"
import script from "./CustomizeEventAdd.vue?vue&type=script&lang=js"
export * from "./CustomizeEventAdd.vue?vue&type=script&lang=js"

import "./CustomizeEventAdd.vue?vue&type=style&index=0&id=6ff55854&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__